import { demoData } from "./api";
import ChartType from "./../components/editorPage/ChartType.json";

export const getDemoData = (chartType) => {
	let chart = "";
	switch (chartType) {
		case ChartType.BasicArea:
			chart = "basicArea";
			break;
		case ChartType.StackedArea:
			chart = "stackedArea";
			break;
		case ChartType.BasicBar:
			chart = "basicBar";
			break;
		case ChartType.StackedBar:
			chart = "stackedBar";
			break;
		case ChartType.PercentBar:
			chart = "percentBar";
			break;
		case ChartType.GroupBar:
			chart = "groupBar";
			break;
		case ChartType.RangeBar:
			chart = "rangeBar";
			break;
		case ChartType.BasicLine:
			chart = "basicLine";
			break;
		case ChartType.MultiLine:
			chart = "multiLine";
			break;
		case ChartType.StepLine:
			chart = "stepLine";
			break;
		case ChartType.ColumnLine:
			chart = "columnLine";
			break;
		case ChartType.PieChart:
		case ChartType.DonutChart:
		case ChartType.WordCloud:
			chart = "pieChart";
			break;
		case ChartType.Histogram:
			chart = "histogram";
			break;
		case ChartType.RadarMultiLine:
			chart = "radarMultiLine";
			break;
		case ChartType.Radar:
			chart = "radar";
			break;
		default:
			break;
	}
	return new Promise((resolve, reject) => {
		if (chart) {
			demoData(chart)
				.then((data) => {
					return resolve(data);
				})
				.catch((e) => {
					return resolve(false);
				});
		} else {
			return resolve(false);
		}
	});
};
